
import React from 'react';
import { Button } from '@/components/ui/button';
import { History } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export const EmptyAppointmentHistory: React.FC = () => {
  const { t } = useTranslation('dashboard');

  return (
    <div className="bg-gray-50 rounded-lg p-8 text-center">
      <History className="h-12 w-12 mx-auto mb-4 text-amber-600" />
      <h3 className="text-lg font-medium mb-2">{t('emptyHistory.title')}</h3>
      <p className="text-gray-600 mb-6">{t('emptyHistory.description')}</p>
      <Button asChild className="bg-amber-600 hover:bg-amber-700 text-white">
        <Link to="/booking-choice">{t('emptyHistory.buttonText')}</Link>
      </Button>
    </div>
  );
};
